// import logo from './logo.svg';
import './App.css';
import Template from './Component/Template/Template';

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <Template />
      </header>
    </div>
  );
}

export default App;
